<template>
  <div class="row">
    <div class="col-md-8">
      <b-card header-tag="header" footer-tag="footer">
        <template #header>
          <h6 class="mb-0 d-flex flex-column flex-md-row">
            <div>
              FOLIO: <strong>{{reservation.folio || '---'}}</strong>
              <small>Creada {{ $moment(reservation.created_at).format('YYYY-MM-DD HH:mm:ss') }}</small>
              <b-badge variant="info">{{reservation.terminal}}</b-badge>
              <b-badge variant="success">{{getZoneName(reservation.service_zone)}}</b-badge>
              <b-button size="sm" :href="urlPrintReservation()" target="_blank" variant="primary">
                <font-awesome-icon :icon="['fas', 'print']"/> Ticket
              </b-button>
            </div>
            <div class="ml-md-auto align-self-md-center">
              <strong class="ml-auto">
                ${{ numberFormat(reservation.total) }}{{ reservation.currency }} 
              </strong>
              <strong class="text-primary">
                &nbsp; | ${{ numberFormat(reservation.quota) }}{{ reservation.currency }}
              </strong>
              <strong class="text-success">
                &nbsp; | ${{ numberFormat(getCommission()) }}{{ reservation.currency }}
              </strong>
            </div>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <Loading :active="loading" :full-page="true"></Loading>
          <ValidationObserver ref="form1" >
            <form action="">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                    id="fieldset-1"
                    description="Nombre completo."
                    label="Cliente"
                    label-for="input-1"
                  >
                    <b-form-input id="input-1" v-model="reservation.customer_name" readonly trim></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    id="fieldset-2"
                    description="Tipo de vehiculo"
                    label="Producto"
                    label-for="input-2"
                  >
                    <b-form-input id="input-2" v-model="reservation.service_name" readonly trim></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    id="fieldset-3"
                    description="Tipo de servicio"
                    label="Servicio"
                    label-for="input-3"
                  >
                    <b-form-input id="input-3" v-model="reservation.service_type" readonly trim></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                    id="fieldset-4"
                    description=""
                    label="Desde"
                    label-for="input-4"
                  >
                    <b-form-input id="input-4" v-model="reservation.from_hotel" readonly trim></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    id="fieldset-5"
                    description="Hotel"
                    label="Hacia"
                    label-for="input-5"
                  >
                    <!-- <b-form-input id="input-5" v-model="reservation.to_hotel"  trim></b-form-input> -->
                    <hotel-autocomplete
                      :default-hotel.sync="toHotel"
                      id="toHotel"
                      :state="stateToHotel"
                      @on-select-hotel="onSelectToHotel"
                      @on-search="onSearch" 
                      :listHotels="hotels"
                    ></hotel-autocomplete> 
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    id="fieldset-6"
                    description="# de clientes"
                    label="Pax"
                    label-for="input-6"
                  >
                    <b-form-input id="input-6" v-model="reservation.pax" readonly trim></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <b-form-group
                id="fieldset-address"
                label="Dirección"
                label-for="address"
              >
                <b-form-input id="address" v-model="r.address" ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-special_request"
                label="Observaciones"
                label-for="special_request"
              >
                <b-form-input id="special_request" v-model="r.special_request" ></b-form-input>
              </b-form-group>
              <p v-if="disabledSubmitDepartureHotel" class="text-danger">Por favor seleccione un hotel de la lista</p>
              <b-button :disabled="disabledSubmitDepartureHotel" @click="onSubmit" variant="primary">Guardar</b-button>
            </form>
          </ValidationObserver>
          <hr>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                id="fieldset-13"
                description=""
                label="Email"
                label-for="input-13"
              >
                <b-form-input id="input-13" v-model="reservation.contact_email" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-14"
                description=""
                label="Tel"
                label-for="input-14"
              >
                <b-form-input id="input-14" v-model="reservation.contact_phone" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-15"
                description=""
                label="País"
                label-for="input-15"
              >
                <b-form-input id="input-15" v-model="reservation.contact_country" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card v-if="reservation.service_type == 'arrival' || reservation.service_type == 'round trip'" class="mt-3" header-tag="header">
        <template #header>
          <h6 class="mb-0">
            <strong class="">
              LLegada
            </strong>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                id="fieldset-7"
                description=""
                label="Fecha y hora"
                label-for="input-7"
              >
                <b-form-input id="input-7" :value="$moment(reservation.arrival_date).format('DD MMM YYYY HH:mm')" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-8"
                description=""
                label="Aerolinea"
                label-for="input-8"
              >
                <b-form-input id="input-8" v-model="reservation.arrival_airline" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-9"
                description=""
                label="#Vuelo"
                label-for="input-9"
              >
                <b-form-input id="input-9" v-model="reservation.arrival_flight" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card v-if="reservation.service_type == 'departure' || reservation.service_type == 'round trip'" class="mt-3" header-tag="header">
        <template #header>
          <h6 class="mb-0">
            <strong class="">
              Salida
            </strong>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                id="fieldset-10"
                description=""
                label="Fecha y hora"
                label-for="input-10"
              >
                <b-form-input id="input-10" :value="$moment(reservation.departure_date).format('DD MMM YYYY HH:mm')" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                id="fieldset-11"
                description=""
                label="Aerolinea"
                label-for="input-11"
              >
                <b-form-input id="input-11" v-model="reservation.departure_airline" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                id="fieldset-12"
                description=""
                label="#Vuelo"
                label-for="input-12"
              >
                <b-form-input id="input-12" v-model="reservation.departure_flight" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                id="fieldset-101"
                description=""
                label="Pickup"
                label-for="input-101"
              >
                <b-form-input id="input-101" :value="$moment(reservation.pickup_time).format('DD MMM YYYY HH:mm')" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card  class="mt-3" header-tag="header">
        <template #header>
          <h6 class="mb-0">
            <strong class="">
              Totales
            </strong>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <table class="table">
            <tbody>
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>${{numberFormat(reservation.total)}}{{reservation.currency}}</strong></td>
              </tr>
              <tr>
                <td>Base</td>
                <td>${{numberFormat(reservation.base_total)}}{{reservation.currency}}</td>
              </tr>
              <tr>
                <td class="text-primary">Cuota</td>
                <td class="text-primary">${{numberFormat(reservation.quota)}}{{reservation.currency}}</td>
              </tr>
              <tr>
                <td class="text-success">Excedente</td>
                <td class="text-success">${{numberFormat(getCommission())}}{{reservation.currency}}</td>
              </tr>
            </tbody>
          </table>
        </b-card-text>
      </b-card>
    </div>
    <div class="col-md-4">
      <reservation-history :reservation="reservation" :update="updateHistory"></reservation-history>
    </div>
  </div>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  import {NumberFormat} from "../../helpers/NumberFormat"
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'ReservationSeller',
    props:['reservation', 'hotels'],
    components:{FontAwesomeIcon, ValidationObserver, ValidationProvider},
    data() {
      return {
        stateToHotel: null,
        updateHistory: false,
        loading: false,
        disabledSubmitDepartureHotel : false,
        toHotel: {
          id:this.reservation.to_hotel_id,
          value:this.reservation.to_hotel,
          to_hotel:this.reservation.to_hotel,
          to_destination_id:this.reservation.to_destination_id,
          to_destination:this.reservation.to_destination
        },
        r:{
          to_hotel_id:this.reservation.to_hotel_id,
          address:this.reservation.address,
          special_request:this.reservation.special_request
        }
      }
    },
    methods:{
      onSearch(search) {
        console.log('search', search);
        this.disabledSubmitDepartureHotel = true
        this.r.to_hotel_id = ''
      },
      isValidToHotel() {
        if(this.r.to_hotel_id !== '') {
          this.stateToHotel = true
          this.disabledSubmitDepartureHotel = false
        } else {
          this.stateToHotel = false
          this.disabledSubmitDepartureHotel = true
        }
        return this.r.to_hotel_id !== ''
      },
      onSelectToHotel(data) {
        
        this.r.to_hotel_id = data.id
        this.toHotel = data
        this.toHotel.to_hotel = data.value
        this.disabledSubmitDepartureHotel = false
      },
      numberFormat(number) {
        return NumberFormat.format(parseFloat(number), 2, ',', '.')
      },
      urlPrintReservation() {
        const item = this.reservation
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations`
        return url+'/'+item.id+'/print-ticket'
      },
      getZoneName(zone) {
        if (zone == 'foreign') {
          return 'Foraneo'
        }
        return 'Local'
      },
      getCommission() {
        if(this.reservation.surplus) {
          return this.reservation.surplus
        }
        return parseFloat(this.reservation.total) - (parseFloat(this.reservation.base_total) + parseFloat(this.reservation.quota))
      },
      onSubmit(e) {
        e.preventDefault()
        this.errors = null
        if(this.isValidToHotel()) {
          
          this.$refs.form1.validate().then((success) => {
            if (success) {
              this.loading = true
              const url = `${process.env.MIX_APP_URL}/api-feraltar/update-departure`
              //this.$store.dispatch('quote/setRequest', this.rq)
              this.$axios.post(url, {
                reservation_id:this.reservation.id,
                r_id_feraltar:this.reservation.r_id_feraltar,
                ... this.toHotel,
                ... this.r
              }).then(rs => {
                //this.$store.dispatch('quote/setData', rs.data)
                if (!rs.data.error) {
                  //window.location.href = url +'/'+ rs.data.id
                  this.loading = false
                  this.updateHistory = !this.updateHistory
                } else {
                  this.loading = false
                }
              })
              .catch(error=> {
                if (error.response) {
                  this.errors = error.response.data.errors
                }  else {
                  this.errors = {
                    unexpected: ['Hubo un error por favor contacte al administrador']
                  }
                }
                console.log('error quote', error);
                this.loading = false
              })
            }
          })
        }
      },
    }
  }
</script>